import type { ShopperAiScope } from "../../keyboard-shortcuts/shopper-ai-shortcuts";
import type { ScopeNode } from "../scope-tree";
import { conversationActionIds, type ConversationActionId } from "./action-ids";

export const priorityScope: ScopeNode<ConversationActionId, ShopperAiScope> = {
  id: "priority",
  label: "Set Priority",
  actionRefs: [
    { actionId: conversationActionIds.priorityLow },
    { actionId: conversationActionIds.priorityMedium },
    { actionId: conversationActionIds.priorityHigh },
    { actionId: conversationActionIds.priorityCritical },
    { actionId: conversationActionIds.priorityClear },
  ],
};

export const snoozeScope: ScopeNode<ConversationActionId, ShopperAiScope> = {
  id: "snooze",
  label: "Snooze",
  actionRefs: [
    { actionId: conversationActionIds.snooze1h },
    { actionId: conversationActionIds.snooze4h },
    { actionId: conversationActionIds.snooze24h },
    { actionId: conversationActionIds.snoozeCustom },
  ],
};

/**
 * Assignee selection scope.
 * Actions are populated at runtime from team members.
 */
export const assignScope: ScopeNode<ConversationActionId, ShopperAiScope> = {
  id: "assign",
  label: "Assign",
  actionRefs: [], // Populated at runtime
};

/**
 * Tag selection scope.
 * Actions are populated at runtime from available tags.
 */
export const addTagScope: ScopeNode<ConversationActionId, ShopperAiScope> = {
  id: "addTag",
  label: "Add Tag",
  actionRefs: [], // Populated at runtime
};

/**
 * Main action menu scope - Alt+<key> shortcuts.
 * Contains direct actions and submenu triggers.
 */
export const actionMenuScope: ScopeNode<ConversationActionId, ShopperAiScope> =
  {
    id: "actionMenu",
    label: "Actions",
    actionRefs: [
      { actionId: conversationActionIds.close },
      { actionId: conversationActionIds.reopen },
      { actionId: conversationActionIds.snooze, childScope: snoozeScope },
      { actionId: conversationActionIds.markRead },
      { actionId: conversationActionIds.markUnread },
      {
        actionId: conversationActionIds.setPriority,
        childScope: priorityScope,
      },
      { actionId: conversationActionIds.assign, childScope: assignScope },
      { actionId: conversationActionIds.addTag, childScope: addTagScope },
      { actionId: conversationActionIds.archive },
      { actionId: conversationActionIds.delete },
    ],
  };

/**
 * Conversation table navigation scope - vim-style keys.
 * Active when focus is on the conversation list.
 */
export const conversationTableScope: ScopeNode<
  ConversationActionId,
  ShopperAiScope
> = {
  id: "conversationTable",
  label: "Conversation List",
  actionRefs: [
    { actionId: conversationActionIds.navigateUp },
    { actionId: conversationActionIds.navigateDown },
    { actionId: conversationActionIds.openConversation },
    {
      actionId: conversationActionIds.openActionMenu,
      childScope: actionMenuScope,
    },
  ],
};
